import { ComponentProps, FC } from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import { cn } from "@/utils/tailwind";

export const RmPopover: FC<ComponentProps<typeof PopoverPrimitive.Root>> = ({
  ...props
}) => {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />;
};

export const RmPopoverTrigger: FC<
  ComponentProps<typeof PopoverPrimitive.Trigger>
> = props => {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
};

export const RmPopoverContent: FC<
  ComponentProps<typeof PopoverPrimitive.Content>
> = ({ className, align = "center", sideOffset = 4, ...props }) => {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        data-slot="popover-content"
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
};

export const RmPopoverAnchor: FC<
  ComponentProps<typeof PopoverPrimitive.Anchor>
> = props => {
  return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />;
};
